const TOKEN_KEY = 'auth_access_token'
const authBase = import.meta.env.VITE_AUTH_SYSTEM_BASE_URL
const appId = import.meta.env.VITE_AUTH_APP_ID

export function readToken(): string | null {
  const url = new URL(window.location.href)
  const token = url.searchParams.get('token')
  if (token) {
    localStorage.setItem(TOKEN_KEY, token)
    url.searchParams.delete('token')
    window.history.replaceState({}, document.title, `${url.pathname}${url.search}${url.hash}`)
    return token
  }
  return localStorage.getItem(TOKEN_KEY)
}

export function requireLogin(): string | null {
  const token = readToken()
  if (token) return token
  if (!authBase || !appId || appId === 'replace-at-deploy') return null
  const params = new URLSearchParams({ app_id: appId, redirect_uri: window.location.href })
  window.location.assign(`${authBase.replace(/\/$/, '')}/authorize?${params}`)
  return null
}

export function logout(): void {
  localStorage.removeItem(TOKEN_KEY)
  if (authBase && appId) {
    window.location.assign(`${authBase.replace(/\/$/, '')}/authorize?${new URLSearchParams({ app_id: appId, redirect_uri: window.location.origin, logout: '1' })}`)
  }
}

